import { mode } from '@chakra-ui/theme-tools';

const Card = {
  baseStyle: (props) => ({
    p: '12px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    borderRadius: 'md',
    minWidth: '0px',
    wordWrap: 'break-word',
    bg: mode('#ffffff', 'navy.800')(props),
    borderWidth: '1px',
    borderColor: mode('gray.200', 'whiteAlpha.200')(props),
    boxShadow: 'none',
    backgroundClip: 'border-box',
  }),
};

export const CardComponent = {
  components: {
    Card,
  },
};
